import OCallingModal from './index.vue';

OCallingModal.install = app => {
  app.component(OCallingModal.name, OCallingModal);
};

export default OCallingModal;
